import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indainNumber'
})
export class IndainNumberPipe implements PipeTransform {

  transform(value: number): string {
    if (value === null || isNaN(value)) {
      return '';
    }

    // const formatted = value.toLocaleString('en-IN');
    const formatted = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return formatted;
  }

}
